import { Controller } from '@hotwired/stimulus'
import { effect } from "@preact/signals-core";
import store from '../store'
import { getFragmentsForSection } from '../section-fragments-store'

const provisionTypes = new Set(['Requirement', 'Recommendation', 'Permission', 'Possibility'])

export default class extends Controller {
  static targets = [ "form", "provisionSqidInput", "addProvisionButton", "addProvisionIcon", "addProvisionText", "approvalStatusForm" ]
  connect() {
    this.isAddingNewProvison = false
    this.sectionSqid = this.element.dataset.sectionSqid
    this.highlightedFragments = []
    this.fragmentElements = this.element.querySelectorAll('.fragment')
    this.sectionFragments = getFragmentsForSection(this.sectionSqid)
    this.effects = [
      store.selectedProvision.effect(() => {
        if (store.selectedProvision.value.sectionSqid === this.sectionSqid) {
          const highlightedIds = this.highlightedFragments.map(f => f.id)
          store.selectedProvision.value.fragmentIds
            .filter(fid => !highlightedIds.includes(fid))
            .forEach(fid => document.getElementById(fid).classList.add('highlight'))
          highlightedIds
            .filter(fid => !store.selectedProvision.value.fragmentIds.includes(fid))
            .forEach(fid => document.getElementById(fid).classList.remove('highlight'))
          this.highlightedFragments = store.selectedProvision.value.fragmentIds
            .map(fid => document.getElementById(fid))
          this.formTarget.setAttribute('action', this.formTarget.dataset.addFragmentUrl)
          this.formTarget.setAttribute('hx-target', `#provision-${store.selectedProvision.value.provisionSqid}-accordion-item`)
          this.formTarget.setAttribute('hx-select', `#provision-${store.selectedProvision.value.provisionSqid}-accordion-item`)

          this.provisionSqidInputTarget.value = store.selectedProvision.value.provisionSqid
          if(this.isAddingNewProvison) {
            this.toggleAddProvision()
          }
        } else {
          this.formTarget.setAttribute('action', this.formTarget.dataset.addProvisionUrl)
          this.formTarget.setAttribute('hx-target', `#section-${this.sectionSqid}-provisions`)
          this.formTarget.setAttribute('hx-select', `#section-${this.sectionSqid}-provisions`)
          this.highlightedFragments.forEach(f => f.classList.remove('highlight'))
          this.highlightedFragments = []
        }
      }),
      store.selectedSectionSqid.effect(() => {
        if (store.selectedSectionSqid.value === this.sectionSqid) {
          this.element.classList.add('selected-section')
        } else {
          this.element.classList.remove('selected-section')
          if(this.isAddingNewProvison) {
            this.toggleAddProvision()
          }
        }
      }),
      effect(() => {
        this.fragmentElements.forEach(fragment => {
          const fragmentProvisionTypes = this.sectionFragments.value.get(fragment.id)
          if (fragmentProvisionTypes) {
            provisionTypes.forEach(provisionType => {
              if(fragmentProvisionTypes.has(provisionType)) {
                fragment.classList.add(provisionType)
              } else {
                fragment.classList.remove(provisionType)
              }
            })
          } else {
            provisionTypes.forEach(provisionType => {
              fragment.classList.remove(provisionType)
            })
          }
        })
      })
    ]
  }

  disconnect() {
    this.effects.forEach(dispose => dispose())
  }

  navigateToProvisionsClicked() {
    document.getElementById(`section-${this.sectionSqid}-provisions`).scrollIntoView()
  }

  addProvisionClicked() {
    store.selectedSectionSqid.set(this.sectionSqid)
    this.toggleAddProvision()
    if(this.isAddingNewProvison) {
      store.selectedSectionSqid.set(this.sectionSqid)
    } else {
      store.selectedSectionSqid.set(null)
    }
  }

  toggleAddProvision() {
    this.isAddingNewProvison = !this.isAddingNewProvison
    const spritePath = this.addProvisionIconTarget.getAttribute('href').split('#')[0]
    if(this.isAddingNewProvison) {
      this.addProvisionButtonTarget.classList.remove('btn-outline-success')
      this.addProvisionButtonTarget.classList.add('btn-outline-danger')
      this.addProvisionIconTarget.setAttribute('href', spritePath + '#x-lg')
      this.addProvisionTextTarget.textContent = 'Cancel adding new provision to section'
      this.element.classList.add('is-adding-provision')
    } else {
      this.addProvisionButtonTarget.classList.add('btn-outline-success')
      this.addProvisionButtonTarget.classList.remove('btn-outline-danger')
      this.addProvisionIconTarget.setAttribute('href', spritePath + '#plus-lg')
      this.addProvisionTextTarget.textContent = 'Add new provision to section'
      this.element.classList.remove('is-adding-provision')
    }
  }

  onApprovalStatusSubmit(e) {
    e.preventDefault()
    if(this.isAddingNewProvison) {
      this.toggleAddProvision()
    }
    store.selectedSectionSqid.set(this.element.dataset.sectionSqid)
    this.approvalStatusFormTarget.requestSubmit(e.target)
  }

}
